// extracted by mini-css-extract-plugin
module.exports = {"withIcon":"TimeInput_withIcon__17Q6-","clockIcon":"TimeInput_clockIcon__2QSrM"};